import styled from 'styled-components'

import { helpers } from 'styles'

export const SecondaryText = styled.p`
	font-size: ${helpers.font.size.baseSmall};
`
